module.exports = __webpack_public_path__ + "media/images/emblems/Belprahon-coat_of_arms-5ba44dc150c55272320aa78c70710612.svg";